import { render } from "./AdminCmsCreate.vue?vue&type=template&id=97dbad3e&scoped=true&ts=true&lang=true"
import script from "./AdminCmsCreate.vue?vue&type=script&lang=ts"
export * from "./AdminCmsCreate.vue?vue&type=script&lang=ts"

import "./AdminCmsCreate.vue?vue&type=style&index=0&id=97dbad3e&scoped=true&lang=css"

import exportComponent from "/var/www/adminold.quickup.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97dbad3e"]])

export default __exports__